import { Component, computed, EventEmitter, input, Output, Signal, ChangeDetectionStrategy } from '@angular/core';
import { PollQuestion } from '../../../../../assets/js/com/ts_api_client';
import { POLLQUESTIONTYPE } from '../../../../bdo/enums/pollQuestionType.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'bdo-poll-question',
    templateUrl: './poll-question.component.html',
    styleUrls: ['./poll-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollQuestionComponent {
  public questionData = input<PollQuestion>();
  public pollId = input<number>();

  public questionText: Signal<string> = computed(() => {
    const questionData = this.questionData();
    const pollId = this.pollId();

    const processNames = this.getProcessNames(pollId);

    switch (questionData?.questionNo) {
      case 1: {
        return this.translateService.instant('satisfactionPoll.questions.question1');
      }
      case 2: {
        return this.translateService.instant('satisfactionPoll.questions.question2', {
          processName: processNames?.name
        });
      }
      case 3: {
        return this.translateService.instant('satisfactionPoll.questions.question3', {
          processAction: processNames?.action
        });
      }
      case 4: {
        return this.translateService.instant('satisfactionPoll.questions.question4', {
          processName: processNames?.name
        });
      }
      default: {
        return '';
      }
    }
  });

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Output() sendAnswer: EventEmitter<string> = new EventEmitter();
  public POLLQUESTIONTYPE = POLLQUESTIONTYPE;

  constructor(protected translateService: TranslateService) {
  }

  /**
   * Get process names and actions based on poll ID
   * Uses switch-case for better performance and clearer structure
   */
  private getProcessNames(pollId: number | undefined): { name: string; action: string } | null {
    if (!pollId) {
      return null;
    }

    switch (pollId) {
      case 1: {
        return {
          name: this.translateService.instant('satisfactionPoll.process.poll1.name'),
          action: this.translateService.instant('satisfactionPoll.process.poll1.action')
        };
      }
      case 2: {
        return {
          name: this.translateService.instant('satisfactionPoll.process.poll2.name'),
          action: this.translateService.instant('satisfactionPoll.process.poll2.action')
        };
      }
      case 3: {
        return {
          name: this.translateService.instant('satisfactionPoll.process.poll3.name'),
          action: this.translateService.instant('satisfactionPoll.process.poll3.action')
        };
      }
      case 4: {
        return {
          name: this.translateService.instant('satisfactionPoll.process.poll4.name'),
          action: this.translateService.instant('satisfactionPoll.process.poll4.action')
        };
      }
      default: {
        return null;
      }
    }
  }
}
